import { usePreferencesContext } from "../context/preferences/context";
import { setLanguage, toggleTheme } from "../context/preferences/action";
import { SUPPORTED_LANGUAGES } from "../common/constants";
import { useTranslation } from "react-i18next";

export const usePreferences = () => {
  const { state, dispatch } = usePreferencesContext();
  const { i18n } = useTranslation();

  const changeLanguage = (language: SUPPORTED_LANGUAGES) => {
    dispatch(setLanguage(language));
    i18n.changeLanguage(language);
  };

  const toggleLanguage = () => {
    const newLanguage =
      state.currentLanguage === SUPPORTED_LANGUAGES.EN
        ? SUPPORTED_LANGUAGES.AR
        : SUPPORTED_LANGUAGES.EN;
    changeLanguage(newLanguage);
  };

  const toggleAppTheme = () => {
    dispatch(toggleTheme());
  };

  return {
    currentLanguage: state.currentLanguage,
    direction: state.direction,
    isDarkMode: state.isDarkMode,
    antdLocale: state.antdLocale,
    changeLanguage,
    toggleLanguage,
    toggleTheme: toggleAppTheme,
  };
};
